<template>
  <div class="card-form">
    <PageMain
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @batchFabricCardListing="batchFabricCardListing"
      @checkbox-change="(r) => (checkRows = r)"
      @printer="({ fabricCardCode }) => labelPrint(fabricCardCode)"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      >
        <template>
          <b-button
            v-if="allow('A')"
            size="sm"
            class="ml-2"
            variant="outline-success"
            @click="openChooseFabric({ pageType: 'add' })"
          >
            <b-icon-plus></b-icon-plus>
            {{ $l('btn_generate_fabric_labels') || '生成面料标签' }}
          </b-button>
          <el-badge
            v-if="allow('P')"
            :value="checkedCount"
            class="printer-button"
            :class="{ clearable: !!checkedCount }"
          >
            <b-button
              size="sm"
              class="printer-button ml-2"
              variant="outline-success"
              :disabled="!checkedCount"
              @click="labelPrint()"
            >
              <b-icon-tag></b-icon-tag>
              {{ $l('INDEX.btn_print_tag') || '标签打印' }}
              <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
            </b-button>
          </el-badge>

          <el-badge
            v-if="allow('M') && checkedCount"
            :value="checkedCount"
            class="printer-button"
            :class="{ clearable: !!checkedCount }"
          >
            <b-button
              size="sm"
              class="printer-button ml-3"
              variant="outline-success"
              @click="batchFabricCardListing(checkRows, false)"
            >
              {{ $l('btn_fabric_shelve') || '面料上架' }}
              <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
            </b-button>
          </el-badge>

          <b-button
            v-if="allow('M') && !checkedCount"
            size="sm"
            class="printer-button ml-3"
            variant="outline-success"
            @click="batchFabricCardListing(checkRows, false)"
          >
            {{ $l('btn_fabric_shelve') || '面料上架' }}
          </b-button>
          <b-button
            v-if="allow('E')"
            size="sm"
            class="ml-3"
            variant="outline-success"
            @click="exportData()"
          >
            <i class="el-icon-folder-opened mr-1"></i>
            {{ $l('INDEX.btn_export') || '导出' }}
          </b-button>
        </template>
      </PageHeader>
      <pagination
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>
    <ChooseFabric
      :visible.sync="chooseFabricOpts.visible"
      multiple
      @confirm="chooseFabricConfirm"
    />
    <FabricCardListing
      :visible.sync="fabricCardData.visibleFabricCardListing"
      :dataList="fabricCardData.dataList"
      :title="fabricCardData.title"
      :isSingle="fabricCardData.isSingle"
      @close="close"
      @reload="reload"
      :treeData="treeData"
    />
    <ChooseTemplate
      :visible.sync="chooseTemplateOptions.visible"
      :title="$l('INDEX.dialog_title_select_export_template') || '选择导出模版'"
      :templateQueryParams="{
        templateGroup: chooseTemplateOptions.templateGroup,
      }"
      :exportOptions="{
        params: chooseTemplateOptions.exportParams,
        checkUrl: chooseTemplateOptions.exportCheckUrl,
      }"
      @close="handleChooseTemplateClose"
      @export-success="handleChooseTemplateClose"
    />
    <el-dialog
      v-if="dialogVisible"
      show-close
      :visible.sync="dialogVisible"
      width="500px"
      :title="$l('dialog_find_location') || '查询库位号'"
      :close-on-click-modal="false"
      :before-close="() => closeExportDialog()"
      destroy-on-close
      append-to-body
    >
      <el-form
        ref="exportForm"
        :model="formData"
        label-width="120px"
        onsubmit="return false"
        :rules="rules"
        style="margin-top: 30px; margin-bottom: 30px;"
      >
        <el-row>
          <el-col :span="20">
            <el-form-item
              :label="$l('form_lable_locationCode') || '库位号'"
              prop="locationNo"
            >
              <el-input
                v-model="formData.locationNo"
                size="medium"
                clearable
                :placeholder="$l('tip_please_input_location') || '请输入库位号'"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="closeExportDialog()">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button type="primary" size="small" @click="confirmExport()">
          {{ $l('INDEX.btn_confirm') || '确认' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import PageHeader from './header.vue'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
import ChooseFabric from '../choose-fabric'
import FabricCardListing from '../fabricCardListing'
import validate from '@/libs/util.validate'
import ChooseTemplate from '@/views/digital/components/choose-template'
export default {
  mixins: [BaseTable, EditLoading],
  components: {
    PageHeader,
    PageMain,
    ChooseFabric,
    FabricCardListing,
    ChooseTemplate,
  },
  data() {
    return {
      usePage: true,
      fabricCardData: {
        visibleFabricCardListing: false,
        dataList: [],
        isSingle: false,
        title: '',
      },
      checkRows: [],
      treeData: [],
      chooseFabricOpts: { visible: false, title: '', extrasParams: {} },
      dialogVisible: false,
      formData: { locationNo: '' },
      chooseTemplateOptions: {
        visible: false,
        templateGroup: 'digicenter-fabricCard',
        exportCheckUrl: '',
        exportParams: {
          locationNo: '',
        },
      },
      rules: {
        locationNo: [
          {
            required: true,
            message: this.$l('tip_please_input_location') || '请输入库位号',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  computed: {
    checkedCount() {
      return this.checkRows?.length || 0
    },
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .fabricCardListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openChooseFabric() {
      this.chooseFabricOpts = {
        visible: true,
      }
    },
    async chooseFabricConfirm(params) {
      const fabricList = params.map((t) => ({
        fabricCode: t.fabricCode,
        generateQuantity: t.generateQuantity,
      }))

      if (this.loadingOpen()) return
      const res = await this.$api
        .fabricCardSaveApi({ fabricList })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_generate_no') || '生成失败！')
        return
      }
      this.reload()
      this.chooseFabricOpts = { visible: false }
    },
    labelPrint(code) {
      const listCode = this.checkRows.map((item) => item.fabricCardCode)
      const codeList = code ? [code] : listCode

      if (!codeList?.length) {
        this.$message({
          showClose: true,
          message: '请选择需要打印的标签',
          type: 'warning',
        })
        return
      }

      this.$api.globalExportData(
        '/digitalCenter/fabric/card/print',
        { codeList },
        '面料标签'
      )
      setTimeout(() => {
        this.clearCheckboxRow()
      }, 0)
    },
    exportData() {
      this.dialogVisible = true
    },
    handleChooseTemplateClose() {
      this.chooseTemplateOptions.visible = false
      this.closeExportDialog()
    },
    async confirmExport() {
      const result = await validate.formValidate([this.$refs.exportForm])
      if (!result) return

      const params = {
        locationNo: this.formData.locationNo,
      }
      const res = await this.$api
        .fabricCardExportCheckApi(params)
        .catch(() => null)
      if (!res) return

      this.dialogVisible = false
      this.chooseTemplateOptions = {
        visible: true,
        templateGroup: 'digicenter-fabricCard',
        exportCheckUrl: '',
        exportParams: {
          ...params,
        },
      }
    },
    closeExportDialog() {
      this.dialogVisible = false
      this.formData = { locationNo: '' }
    },
    clearCheckboxRow() {
      this.$refs.main.clearCheckboxRow()
    },
    async batchFabricCardListing(data, isSingle) {
      const res = await this.$api.warehouseTreeApi()
      this.treeData = res.body.data
      this.fabricCardData = {
        visibleFabricCardListing: true,
        dataList: [...data],
        isSingle,
        title: isSingle
          ? this.$l('dialog_shelve') || '面料上架'
          : this.$l('dialog_batch_shelve') || '面料批量上架',
      }
    },
    close() {
      this.fabricCardData = {
        visibleFabricCardListing: false,
        dataList: [],
        title: '',
      }
      this.closeExportDialog()
      this.clearCheckboxRow()
    },
  },
}
</script>
<style lang="scss" scoped>
.printer-button {
  .el-icon-circle-close {
    display: none;
  }
}
.printer-button.clearable:hover {
  .el-icon-circle-close {
    display: inline-block;
    z-index: 999;
  }
  .el-icon-circle-close:hover {
    transform: scale(1.2);
  }
}
</style>
